import { FC } from 'react';
import { IConversationRunContainer } from '../model/containers/ConversationRunContainer';
import { useContainerRendererFactory } from './hooks/useContainerRendererFactory';
import { useEventRefresher } from '@zdrbm/zdr-react';
import { IConversationRun } from '../model/ConversationRun';
import React from 'react';

export interface AssistantContainerResponseProps {
    run: IConversationRun;
    container: IConversationRunContainer;
    isLastRun: boolean;
}

export const AssistantContainerResponse: FC<AssistantContainerResponseProps> = React.memo(({
    container,
    run,
    isLastRun,
}) => {
    const rendererFactory = useContainerRendererFactory();
    useEventRefresher(container.data);
    const renderer = container.selectFromFactory(rendererFactory);

    const renderResult = renderer.render(run, container);

    return (
        <>
            {renderResult?.content ?? null}
            {isLastRun && (renderResult?.userActions ?? null)}
        </>
    );
});
